import ModalForm from './ModalForm';
import ModalTable from './ModalTable';
import DarkModal from './DarkModal';

export { ModalForm, ModalTable, DarkModal }